module.exports = __webpack_public_path__ + "static/media/clearbit-mobiles-1-tiny.21f58e8e.jpg";